export class TipoSorteioModel {

    public codTipoSorteioPremiacaoConsumidor: number;

    public desTipoSorteioPremiacaoConsumidor: string;
    
    public dataAtualizacao: Date;
}


// WEBPACK FOOTER //
// ./src/app/shared/model/tipo-sorteio.model.ts